// Shared bits of the task panels (US 9478)

// The icon of the asset a task is about
export function assetIcon(model) {
  const icons = {
    'App\\System\\Models\\System': 'desktop',
    'App\\Activity\\Models\\Activity': 'cubes',
    'App\\Process\\Models\\Process': 'cube',
    'App\\Maintenance\\ThirdParty\\Models\\ThirdParty': 'file-signature',
    'App\\Maintenance\\Policy\\Models\\Policy': 'file-invoice'
  };
  return (model && icons[model.who_am_i]) || 'folder-open';
}
